import { useState } from "react";
import axios from "axios";
import { BASE_SPRING_ENDPOINT } from "../../../../api/config";
import { springBaseUrl } from "../../constants/AmplitudeConstants";

const usePrintRegistrationCard = (bookingId, manualResCard) => {
  const [printLoading, setPrintLoading] = useState(false);
  const [printSuccess, setPrintSuccess] = useState(false);

  const handlePrintRegCard = () => {
    setPrintLoading(true);
    setPrintSuccess(false);
    const finalApiUrl = manualResCard
      ? `${springBaseUrl}core/api/v1/rescard/get-rescard?bookingId=${bookingId}&fillDetails=${!manualResCard}`
      : `${springBaseUrl}web-api/get-registration-card-pdf/?bookingId=${bookingId}`;
    axios
      .get(finalApiUrl, {
        headers: {
          Accept: "application/pdf",
          Authorization: localStorage.getItem("token"),
        },
        responseType: "blob",
      })
      .then(async (response) => {
        setPrintLoading(false);
        setPrintSuccess(true);
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = url;
        document.body.appendChild(iframe);
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      })
      .catch(() => {
        setPrintLoading(false);
      });
  };

  return {
    printLoading,
    printSuccess,
    handlePrintRegCard,
  };
};

export default usePrintRegistrationCard;
